module.exports = __webpack_public_path__ + "img/hr-sand-decal-27.54ca9ad5.png";